import { AnalyticEvent } from "../models/AnalyticEvent";
import { fetchWithAuthentication } from "../utilities/FetchUtil";

export const searchAnalyticEvents = async (
  pageNum: number,
  startDate: string,
  endDate: string,
  setTotalPages: (newValue: number) => void,
  setTotalNumber: (newValue: number) => void,
  setLoading: (newValue: boolean) => void,
  pageSize: number = 50,
): Promise<AnalyticEvent[]> => {
  setLoading(true);

  if (pageNum === 0) {
    setLoading(false);
    return [];
  }

  try {
    const response = await fetchWithAuthentication(
      `/analytic_events?pageNum=${pageNum}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}`,
      "GET",
      null,
    );
    const data = await response.json();
    setTotalPages(data.totalPage);
    setTotalNumber(data.totalNumber);
    return data.analyticEvents || [];
  } catch (error) {
    console.error("Error searching analyticEvents:", error);
    return [];
  } finally {
    setLoading(false);
  }
};

export const exportAnalyticEventsCsv = async (
  startDate: string,
  endDate: string,
  setLoading: (newValue: boolean) => void,
) => {
  try {
    setLoading(true);
    const response = await fetchWithAuthentication(
      `/analytic_events/csv?startDate=${startDate}&endDate=${endDate}`,
      "GET",
      null,
    );

    if (!response.ok) {
      throw new Error(`Failed to export CSV, response returned: ${response}`);
    }

    // Get the filename from the Content-Disposition header (e.g. 'attachment; filename="analytic_events.csv"')
    const contentDisposition = response.headers.get("Content-Disposition");
    let fileName = "analytic_events.csv"; // Default fallback filename

    if (contentDisposition) {
      const matches = /filename="([^"]+)"/.exec(contentDisposition);
      if (matches && matches[1]) {
        fileName = matches[1];
      }
    }

    // Create blob and trigger download
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName; // Use the file name from the response header
    document.body.appendChild(a);
    a.click(); // Trigger download
    document.body.removeChild(a); // Cleanup

    window.URL.revokeObjectURL(url); // Release memory
  } catch (error) {
    console.error("Failed to download CSV", error);
    alert(
      "Oops! Something went wrong while exporting the CSV. Please try again later.",
    );
  } finally {
    setLoading(false);
  }
};
